/**
 * toolsMru.js — the "recently opened tools" list, one per browser.
 *
 * Written by every tool visit (the Tools rail records the page it is mounted
 * on) and read by ToolsQuickSearch, which ranks these first on an empty query.
 * Kept under the key the quick search has always used so nobody's history
 * resets. Newest first, capped at eight, silently inert when storage is
 * unavailable (private mode, quota). Official tools are stored by id, saved
 * (agent-built) tools as `my:<id>` (2026-10-02) — userToolKey.
 */

export const userToolKey = (id) => `my:${id}`;

const MRU_KEY = 'tools-quick-search-recent';
const MRU_MAX = 8;

export function readToolsMru() {
  try {
    const raw = JSON.parse(localStorage.getItem(MRU_KEY) || '[]');
    return Array.isArray(raw) ? raw.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function pushToolsMru(id) {
  if (!id) return;
  try {
    const next = [id, ...readToolsMru().filter((x) => x !== id)].slice(0, MRU_MAX);
    localStorage.setItem(MRU_KEY, JSON.stringify(next));
  } catch {
    /* quota / private mode */
  }
}
